module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-center-content"
  }, [_c('h4', [_vm._v("版权管理")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("1.  如何上传我的作品？")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "649px",
      "border": "1px solid #eee"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "copyrightHelpCenter/img_4.jpeg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("入驻成功后，你可进入版权工作台，点击【上传版权内容】按钮，开始提交你的作品 。")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "666px",
      "border": "1px solid #eee"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "copyrightHelpCenter/img_5.png")
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "800px",
      "border": "1px solid #eee"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "copyrightHelpCenter/img_9.jpeg")
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "title",
    attrs: {
      "id": "isSolo"
    }
  }, [_vm._v("2.  独家 / 非独家授权有什么区别？")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "title",
    attrs: {
      "id": "fee"
    }
  }, [_vm._v("3.  版权方是否承担费用有什么区别？")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("\n        * 净收益为通过您发布的付费型音频专辑获得的总收入（用户付费收入以及广告收入）扣除成本（包括但不限于渠道成本、支付成本、促销成本等费用）。\n    ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("你需要填写作品的相关信息，包括书籍名称、ISBN号、出版社、简介等，并上传书籍封面和内容文本。"), _c('br'), _vm._v("\n        除此之外，你还需要填写授权信息，并提供相应作品版权证明和授权文件。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("如果你是作家，你需要下载个人授权书模板，签署后上传。"), _c('br'), _vm._v("\n        如果你代表出版机构，除了版权机构授权书外，你还需要提供版权追溯文件")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("独家授权：")]), _c('br'), _vm._v("\n        与喜马拉雅建立独家合作，喜马拉雅会给合作的出版机构、作者、主播更多的展示机会，更细致的服务，和更多的潜在收益。 "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("非独家授权：")]), _c('br'), _vm._v("\n        您的作品会在喜马拉雅按照普通的付费专辑进行售卖，在资源允许的时候，会给您给予一定程度的推广服务。"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("\n        版权方是否承担费用，意味着不同的制作流程和收益分配方式（参见表格）。"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "copyright"
  }, [_c('tr', [_c('th', [_vm._v("事项")]), _c('th', [_vm._v("平台承担费用")]), _c('th', [_vm._v("版权方承担费用")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("上传版权作品")]), _c('td', [_vm._v("版权方")]), _c('td', [_vm._v("版权方")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("发布海选任务招募主播")]), _c('td', [_vm._v("平台")]), _c('td', [_vm._v("版权方")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("挑选主播")]), _c('td', [_vm._v("平台")]), _c('td', [_vm._v("版权方")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("跟进有声作品录制")]), _c('td', [_vm._v("平台")]), _c('td', [_vm._v("版权方")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("分发录制音频至喜马拉雅平台")]), _c('td', [_vm._v("平台")]), _c('td', [_vm._v("平台")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("承担主播录制费用")]), _c('td', [_vm._v("平台")]), _c('td', [_vm._v("版权方")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("获取收益比例")]), _c('td', [_vm._v("30%")]), _c('td', [_vm._v("50%")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-382dbf98!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/helpCenter/HelpCenterCopyrightManagement.vue
// module id = 558
// module chunks = 0